import '@/shared/styles/global.scss';
import './App.scss';

import React from 'react';
import { Toaster } from 'sonner';

import { ConnectTelegramPage } from '@/pages/connect-telegram/ConnectTelegramPage';
import { env } from '@/shared/config/env';
import { twa } from '@/shared/lib/telegram/twa';

import { Providers } from './providers';
import { AppRouter } from './router';

export const App: React.FC = () => {
  if (env.ENVIRONMENT === 'production' && !twa.isInsideTelegram()) {
    return (
      <Providers>
        <ConnectTelegramPage />
      </Providers>
    );
  }

  return (
    <Providers>
      <div className="app">
        <div className="app__content">
          <AppRouter />
        </div>
      </div>
      <Toaster
        position="top-center"
        offset="24px"
        mobileOffset={{
          top: 'calc(max(var(--tg-safe-area-inset-top, 0px), var(--tg-content-safe-area-inset-top, 0px)) + 40px)',
        }}
        theme="dark"
      />
    </Providers>
  );
};
